import {
    COMMUNITY_MEMBERS_LIST_RESPONSE,
    COMMUNITY_MANAGERS_LIST_RESPONSE,
    COMMUNITY_FOLLOWERS_LIST_RESPONSE,
    COMMUNITY_AWAITING_APPROVAL_LIST_RESPONSE,
    COMMUNITY_CANCEL_MODEL_UPDATE,
    COMMUNITY_PROMOTE_MEMBER,
    USER_LIST_RESPONSE,
    USER_ITEM_RESPONSE,
    USER_ITEM_SAVE_RESPONSE,
    UNAUTHENTICATED
} from "../../actions/action-types"
import { extractEntitiesFromData } from "./entity-reducer-utils"
import { normalise } from "../../models/entities/user"

export default (state = {}, action) => {
    const { type, data, searchCriteria, receivedAt } = action
    switch (type) {
        case COMMUNITY_MEMBERS_LIST_RESPONSE:
        case COMMUNITY_MANAGERS_LIST_RESPONSE:
        case COMMUNITY_FOLLOWERS_LIST_RESPONSE:
        case COMMUNITY_AWAITING_APPROVAL_LIST_RESPONSE:
            return extractEntitiesFromData(
                data,
                state,
                true,
                (newEntity, storedEntity) => {
                    storedEntity = storedEntity || {}
                    const communityId = searchCriteria.get("communityId")
                    return {
                        ...storedEntity,
                        ...newEntity,
                        is_member: mergeWithId(
                            newEntity.is_member,
                            storedEntity.is_member,
                            communityId
                        ),
                        is_manager: mergeWithId(
                            newEntity.is_manager,
                            storedEntity.is_manager,
                            communityId
                        ),
                        community_roles: mergeWithId(
                            newEntity.community_roles,
                            storedEntity.community_roles,
                            communityId
                        )
                    }
                }
            )
        case COMMUNITY_PROMOTE_MEMBER:
            const { member: { id }, communityId } = action
            return {
                ...state,
                [id]: {
                    ...state[id],
                    [`isPromoted_${communityId}`]: true
                }
            }
        case COMMUNITY_CANCEL_MODEL_UPDATE:
            return Object.keys(state)
                .map(key => state[key])
                .map(user => {
                    const userKeys = Object.keys(user)
                    const nonPromotionKeys = userKeys.filter(
                        key => key.indexOf("isPromoted") === -1
                    )
                    if (nonPromotionKeys.length === userKeys.length)
                        // No need to modify user, just return them
                        return user
                    else
                        return nonPromotionKeys.reduce((entity, currentKey) => {
                            entity[currentKey] = user[currentKey]
                            return entity
                        }, {})
                })
                .reduce((newState, entity) => {
                    newState[entity.id] = entity
                    return newState
                }, {})
        case USER_LIST_RESPONSE:
            return extractEntitiesFromData(data, state)
        case USER_ITEM_SAVE_RESPONSE:
        case USER_ITEM_RESPONSE: {
            const { id } = data

            return {
                ...state,
                [id]: {
                    ...normalise(data),
                    lastUpdatedAt: receivedAt
                }
            }
        }
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}

function mergeWithId(newValue, oldValue, id) {
    return {
        ...(oldValue || {}),
        [id]: newValue
    }
}
